import { render, staticRenderFns } from "./WrsWizardStepButtons.vue?vue&type=template&id=37198812&"
import script from "./WrsWizardStepButtons.vue?vue&type=script&lang=js&"
export * from "./WrsWizardStepButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports